<div class="mb-kh-4 white">
  <p *ngIf="step !== 3" class="body-main-text">{{ 'EXPLORE_ACTIVITIES_BLOCK.PLANNING_AN_ACTIVITY_FOR_A' | translate }}</p>
  <p *ngIf="step === 3" class="body-main-text">{{ 'EXPLORE_ACTIVITIES_BLOCK.CHOOSE_A_GRADE_LEVEL_TO' | translate }}</p>
</div>

<div *ngIf="step === 2" class="d-flex explore-activities-options-container">
  <div class="explore-activities-option-button bg-blue-main medium-title-text border-radius-base cursor w-100 mt-large" (click)="optionSelected(exploreActivitiesOptions.ContinueWithExistingClass)">
    <ng-container>{{ 'EXPLORE_ACTIVITIES_BLOCK.CONTINUE_WITH_AN_EXISTING_CLASS' | translate }}</ng-container>
  </div>

  <div class="explore-activities-option-button bg-blue-main medium-title-text border-radius-base cursor w-100 mt-large" (click)="optionSelected(exploreActivitiesOptions.CreateNewClass)">
    <ng-container>{{ 'EXPLORE_ACTIVITIES_BLOCK.CREATE_A_NEW_CLASS' | translate }}</ng-container>
  </div>
</div>

<div *ngIf="step == 1 || step == 3">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 col-sm-4 pl-kh-0 pr-xs mb-small">
        <div class="border-radius-sm">
          <kh-primary-dropdown class="w-100" [items]="countries" [selectedItem]="country" [getName]="getNameForDropdown" [placeHolder]="'EXPLORE_ACTIVITIES_BLOCK.COUNTRY' | translate" (itemClick)="countrySelected($event)"></kh-primary-dropdown>
        </div>
      </div>

      <div class="col-12 col-sm-4 pl-kh-0 pr-xs mb-small">
        <div class="border-radius-sm">
          <kh-primary-dropdown class="w-100" [items]="country?.Regions" [selectedItem]="region" [placeHolder]="'EXPLORE_ACTIVITIES_BLOCK.REGION' | translate" [getName]="getNameForDropdown" (itemClick)="region = $event"></kh-primary-dropdown>
        </div>
      </div>

      <div class="col-12 col-sm-4 pl-kh-0 pr-xs mb-small">
        <div class="border-radius-sm">
          <kh-primary-dropdown class="w-100" [items]="region?.Courses" [selectedItem]="course" [placeHolder]="'EXPLORE_ACTIVITIES_BLOCK.GRADE' | translate" [getName]="getNameForDropdown" [disabled]="!region" (itemClick)="course = $event"></kh-primary-dropdown>
        </div>
      </div>
    </div>
    <span *ngIf="error" class="d-block text-danger spacer-md">{{error}}</span>
  </div>

  <button class="explore-activities-button bg-blue-main medium-title-text border-radius-base mt-kh-4" (click)="nextStep()">
    <ng-container *ngIf="!isGuest && !hasClassesToPick">{{ 'EXPLORE_ACTIVITIES_BLOCK.CREATE_A_NEW_CLASS_AND' | translate }}</ng-container>
    <ng-container *ngIf="hasClassesToPick && step === 1">{{ 'EXPLORE_ACTIVITIES_BLOCK.CONTINUE' | translate }}</ng-container>
    <ng-container *ngIf="isGuest || step === 3">{{ 'EXPLORE_ACTIVITIES_BLOCK.START_EXPLORING' | translate }}</ng-container>
  </button>
</div>

<div class="mt-kh-4" *ngIf="step > 1">
  <span class="medium-title-text blue-accessible" (click)="prevStep()">{{ 'EXPLORE_ACTIVITIES_BLOCK.GO_BACK' | translate }}</span>
</div>
